import {
  CLASS_NAMES,
  PIXEL_NAME,
  SCALE,
  TICK_TIME,
  TILE_SIZE,
} from "../../utils/constants";
import UI from "../UI";
import Empty from "./Empty";
import Explosion from "./Explosion";
import Fallable from "./Fallable";

export default class Barrel extends Fallable {
  constructor(id, level) {
    super({
      id,
      isRigid: false,
      isBreakable: true,
      isFlat: true,
      isPickable: false,
      isCrushable: true,
      level,
    });
    this.reach = 1;
    this.strength = 5;
    this.objectsToDestroyByExplostion = [];
    this.objectsToReachByExplostion = [];
    this.exploded = false
    this.key = Math.random();
  }
  addedToScene() {
    let particles = this.level.scene.add.particles("spark").setScale(SCALE);
    this.emitter = particles.createEmitter();
    this.emitter.setQuantity(15);
    this.emitter.setFrequency(1000);
    this.emitter.setAngle({ min: -180, max: 90 });
    this.emitter.setSpeed({ min: 5, max: 7 });
    this.emitter.setGravityY(1);
    this.emitter.setGravityX(0.01);
    this.emitter.setLifespan({ min: 1000, max: 5000 });
    this.emitter.alpha.onChange(0.5);
    this.emitter.tint.onChange(0xd25400);
    this.emitter.stop();
  }
  explode() {
    if(this.exploded) { return false; }
    this.alien?.destroy();

    // remove barrel: filtering moveables doesn't work since movables are locally referenced and are ot affected by this.
    // this.level.moveables = this.level.moveables.filter((e) => e !== this);

    this.level.parallelMovables = this.level.parallelMovables.filter(
      (e) => e !== this
    );
    this.level.replaceByEmpty(this);
    this.exploded = true;

    // freeze explosion places so objects can not move before the explosion triggers
    for (
      let x = this.position.x - this.reach;
      x <= this.position.x + this.reach;
      x++
    ) {
      for (
        let y = this.position.y - this.reach;
        y <= this.position.y + this.reach;
        y++
      ) {
        const burntEl = this.level.getObjectAt(x, y);
        const burntWillBreak =
          burntEl.isBreakable && (burntEl.strength || 0) < 10; // explosion.power
        if (burntWillBreak && !this.level.objectIsEmpty(burntEl)) {
          this.objectsToDestroyByExplostion.push(burntEl);
          if (burntEl.isClass(CLASS_NAMES.FALLABLE)) {
            // prevent to keep moving by removing it from movables
            burntEl.freeze = true;
            // this.level.moveables = this.level.moveables.filter(
            //   (e) => e !== burntEl
            // );
            this.level.parallelMovables = this.level.parallelMovables.filter(
              (e) => e !== burntEl
            );
          }
        }
        if (!burntWillBreak && !this.level.objectIsEmpty(burntEl)) {
          // reach but not destroy
          this.objectsToReachByExplostion.push(burntEl);
        }
        if (burntWillBreak || this.level.objectIsEmpty(burntEl) || (burntEl && burntEl.isClass(CLASS_NAMES.EXPLOSION))) {
          // complete explosion matrix with empty elements to replace them later with explosion objects
          const explosionPlaceholder = new Explosion(
            PIXEL_NAME.EXPLOSION,
            this.level
          );
          explosionPlaceholder.setPosition({ x, y });
          this.level.setObjectAt(x, y, explosionPlaceholder);
          this.objectsToDestroyByExplostion.push(explosionPlaceholder);
        }
      }
    }
    // this.onExplode()
    // setTimeout(() => this.onExplode(), TICK_TIME/2)
    setTimeout(() => this.onExplode(), TICK_TIME / 2);

    this.level.scene.events.emit("sounds:explosion");
    this.level.scene.events.emit("barre:explode", this);
    this.level.scene.cameras.main.shake(500, 0.003);
  }

  onExplode() {
    const lvl = this.level;
    this.objectsToDestroyByExplostion.forEach((burntEl) => {
      const explosion = new Explosion(PIXEL_NAME.EXPLOSION, lvl);
      if (!burntEl.isClass(Explosion)) {
        burntEl.overrunBy(explosion);
        lvl.onDestroyElement(burntEl);
      }
    });
    this.objectsToDestroyByExplostion = [];

    this.objectsToReachByExplostion.forEach((reachedEl) => {
      // in some cases when an explosion reaches a Barrel, the barrel is destroyed between the collect of this.objectsToReachByExplostion
      // and the execution of this function, resulting reachedEl to be false bcs was destroyed by another process.
      if (reachedEl) {
        reachedEl.hitBy(new Explosion(PIXEL_NAME.EXPLOSION, this.level));
      }
    });
    this.objectsToReachByExplostion = [];

    this.emitter.setPosition(
      {
        min: UI.tileToPixels(this.position.x),
        max: UI.tileToPixels(this.position.x + 1),
      },
      {
        min: UI.tileToPixels(this.position.y),
        max: UI.tileToPixels(this.position.y + 1),
      }
    );
    // this.emitter.start()
    this.level.onNextTick((lvl) => {
      this.emitter.stop();
    });
  }
  overrunBy() {
    this.explode();
    // setTimeout(() => this.explode(), TICK_TIME/2)
  }
  runningOver(el) {
    if(!el.isClass(CLASS_NAMES.EXPLOSION)) {
      this.explode()
    }
    // console.log(this.key, 'barrel overrunning:', el);
  }
}
Barrel.className = CLASS_NAMES.BARREL;
